import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ANALYTICS_ACTION_TYPES, ANALYTICS_ITEM_TYPES, ANALYTICS_OBJECT_TYPES } from '@fttb/common';
import { selectCommonAnalyticsData } from "../../../../analytics/selectors";
import { getAnalyticsEventType } from "../../../selectors";
import { selectCurrentViewTexts, selectInputError } from "../../selectors";
import { sendParamsWithBlockName } from "../../analytics";
export var handleViewAddressInputError = function handleViewAddressInputError(address) {
  return function (_, getState) {
    var state = getState();
    var commonAnalyticData = selectCommonAnalyticsData(state);
    var pageType = getAnalyticsEventType(state);
    var _selectCurrentViewTex = selectCurrentViewTexts(state),
      title = _selectCurrentViewTex.title;
    var inputErrorText = selectInputError(state);
    sendParamsWithBlockName(pageType, _objectSpread(_objectSpread({}, commonAnalyticData), {}, {
      action: ANALYTICS_ACTION_TYPES.view,
      item_type: ANALYTICS_ITEM_TYPES.notification,
      notification_text: inputErrorText,
      object_type: ANALYTICS_OBJECT_TYPES.block,
      block_title: title,
      field_text: address,
      action_id: '2.0'
    }));
  };
};